<template>
<div class="chapter">
<div class="inner_page">
<h2 class="sigil_not_in_toc" id="_idParaDest-2">Contents</h2>
<p class="body"></p>
<p class="firstcenter"><a href="#/Text/dia#_idTextAnchor001">Diagram of the Human Brain</a></p>
<p class="firstcenter"><a href="#/Text/preface#_idTextAnchor002">Preface</a></p>
<p class="firstcenter"><a href="#/Text/ack#_idTextAnchor007">Acknowledgments</a></p>
<p class="body"></p>
<blockquote>
<p class="firstcenter"><a href="#/Text/pt1#_idTextAnchor008"><b>SECTION 1</b><br/>God, the Brain and What Went Wrong</a></p>
</blockquote>
<blockquote>
<p class="firstcenter"><a href="#/Text/ch1#_idTextAnchor010"><b>Chapter 1</b><br/>
God Is Love</a></p>
<p class="firstcenter"><a href="#/Text/ch2#_idTextAnchor017"><b>Chapter 2</b><br/>The Human Brain and Broken Love</a></p>
<p class="firstcenter"><span href="#/Text/ch3#_idTextAnchor032" title="Link target outside of Sample"><b>Chapter 3</b><br/>
The Infection of Fear</span></p>
<p class="center"></p>
<p class="firstcenter"><span href="#/Text/ch4#_idTextAnchor048" title="Link target outside of Sample"><b>Chapter 4</b><br/>
Freedom to Love</span></p>
</blockquote>
<blockquote>
<p class="firstcenter"><span href="#/Text/pt2#_idTextAnchor062" title="Link target outside of Sample"><b>SECTION II</b> <br/>The Battle Between The Conflicting Views About God</span></p>
</blockquote>
<blockquote>
<p class="firstcenter"><span href="#/Text/ch5#_idTextAnchor063" title="Link target outside of Sample"><b>Chapter 5</b><br/>Love Strikes Back</span></p>
<p class="firstcenter"><span href="#/Text/ch6#_idTextAnchor064" title="Link target outside of Sample"><b>Chapter 6</b><br/>Engaging the Battle</span></p>
<p class="firstcenter"><span href="#/Text/ch7#_idTextAnchor065" title="Link target outside of Sample"><b>Chapter 7</b><br/>Love Stands Firm</span></p>
<p class="firstcenter"><span href="#/Text/ch8#_idTextAnchor067" title="Link target outside of Sample"><b>Chapter 8</b><br/>Changing Our View of God</span></p>
<p class="firstcenter"><span href="#/Text/ch9#_idTextAnchor069" title="Link target outside of Sample"><b>Chapter 9</b><br/>The Power of Truth</span></p>
<p class="firstcenter"><span href="#/Text/ch10#_idTextAnchor072" title="Link target outside of Sample"><b>Chapter 10</b><br/>The Truth About Sin</span></p>
<p class="firstcenter"><span href="#/Text/ch11#_idTextAnchor073" title="Link target outside of Sample"><b>Chapter 11</b><br/>Enlarging Our View of God</span></p>
<p class="firstcenter"><span href="#/Text/ch12#_idTextAnchor076" title="Link target outside of Sample"><b>Chapter 12</b><br/>The Judgment of God</span></p>
<p class="firstcenter"><span href="#/Text/ch13#_idTextAnchor078" title="Link target outside of Sample"><b>Chapter 13</b><br/>In the Brain of Christ</span></p>
</blockquote>
<blockquote>
<p class="firstcenter"><span href="#/Text/pt3#_idTextAnchor098" title="Link target outside of Sample"><b>SECTION III</b><br/>Embracing the Goodness of God</span></p>
</blockquote>
<blockquote>
<p class="firstcenter"><span href="#/Text/ch14#_idTextAnchor099" title="Link target outside of Sample"><b>Chapter 14</b><br/>Forgiveness</span></p>
<p class="firstcenter"><span href="#/Text/ch15#_idTextAnchor104" title="Link target outside of Sample"><b>Chapter 15</b><br/>When Good Prevails</span></p>
<p class="firstcenter"><span href="#/Text/ch16#_idTextAnchor108" title="Link target outside of Sample"><b>Chapter 16</b><br/>When Love Burns Free</span></p>
<p class="firstcenter"><span href="#/Text/ch17#_idTextAnchor112" title="Link target outside of Sample"><b>Chapter 17</b><br/>Buddha, Jesus and Preparing Your Brain for Eternity</span></p>
<p class="firstcenter"><span href="#/Text/add#_idTextAnchor127" title="Link target outside of Sample"><b>Addendum</b><br/>Putting It All Together—Simple Steps to a Healthier Brain</span></p>
</blockquote>
<p class="firstcenter"><span href="#/Text/studyguide#_idTextAnchor128" title="Link target outside of Sample">Study Guide</span></p>
<p class="firstcenter"><span href="#/Text/gloss#_idTextAnchor146" title="Link target outside of Sample">Glossary</span></p>
<p class="firstcenter"><span href="#/Text/notes#_idTextAnchor147" title="Link target outside of Sample">Notes</span></p>
<p class="firstcenter"><span href="#/Text/praise#_idTextAnchor247" title="Link target outside of Sample">Praise for <i class="i">The God-Shaped Brain</i></span></p>
<p class="firstcenter"><span href="#/Text/ata#_idTextAnchor248" title="Link target outside of Sample">About the Author</span></p>
<p class="firstcenter"><span href="#/Text/moreivp#_idTextAnchor249" title="Link target outside of Sample">More Titles from InterVarsity Press</span></p>
<p class="firstcenter"><span href="#/Text/rights#_idTextAnchor250" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?9e208d70